<template>
  <form
    class="form form_w403 form_pt100 form_pt_m60"
    @submit.prevent="doAction"
  >
    <div class="form__head mb24">
      <h2 class="form__title">{{ $t("auth.login") }}</h2>
    </div>

    <div class="form__content">
      <div class="form-item mb24">
        <vue-tel-input
          :defaultCountry="defaultCountry"
          v-model="form.phone"
          @validate="checkValue"
          :placeholder="$t('forms.phone')"
          :inputOptions="{ showDialCode: true }"
          mode="international"
          :ref="'vue-tel-ref'"
        ></vue-tel-input>
      </div>

      <div
        class="form-item mb10 visible"
        :class="{
          visible_undo: isSubmit,
        }"
      >
        <el-input
          :placeholder="$t('auth.code')"
          type="text"
          v-model="form.code"
          autocomplete="off"
          maxlength="4"
        ></el-input>
      </div>

      <div
        class="form-item mb24 visible"
        :class="{
          visible_undo: isSubmit,
        }"
      >
        <span
          @click="openPrevStep"
          class="form-item__link form-item__link_block form-item__text_foz12"
          >an ein anderes Telefon gesendet</span
        >
      </div>

      <div
        class="form-item mb24 visible"
        :class="{
          visible_undo: isSubmit,
        }"
      >
        <p class="form-item__text form-item__text_grey form-item__text_foz12">
          {{ $t("auth.codeSend") }}
        </p>
      </div>

      <div
        class="form-item mb24 visible"
        :class="{
          visible_undo: isSubmit,
        }"
      >
        <p
          class="form-item__text form-item__text_grey form-item__text_foz12"
          v-if="isSended"
        >
          {{ $t("auth.sendAgainAfter") }} {{ minutes }}:{{ seconds }}
        </p>
        <p
          class="form-item__text form-item__text_grey form-item__text_foz12"
          v-else
        >
          {{ $t("auth.didntReceive") }}
          <a class="form-item__link form-item__link_block" @click="sendAgain">{{
            $t("auth.sendAgain")
          }}</a>
        </p>
      </div>

      <div class="form-item">
        <button
          class="btn btn_upper"
          :disabled="!isValid"
          :class="{
            btn_disabled: !isValid,
          }"
        >
          {{ $t("buttons.continue") }}
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import {
  required,
  requiredIf,
  minLength,
  maxLength,
} from "vuelidate/lib/validators";
import { mapActions } from "vuex";

export default {
  name: "login",
  computed: {
    isValid() {
      return !this.$v.$invalid && this.isValidPhone;
    },
  },
  data() {
    return {
      form: {
        phone: "",
        code: "",
      },

      view: "step_1",
      isValidPhone: false,
      isSubmit: false,
      isSended: false,

      minutes: 1,
      seconds: "00",
      defaultCountry: "de",
    };
  },
  validations: {
    form: {
      phone: {
        required,
      },
      code: {
        minLength: minLength(4),
        maxLength: maxLength(4),
        required: requiredIf(function() {
          if (this.view != "step_1") {
            return true;
          }

          return false;
        }),
      },
    },
  },
  methods: {
    ...mapActions({
      verifyCode: "auth/verifyCode",
      send: "auth/send",
    }),
    resetParams() {
      this.isSended = false;
      this.seconds = "00";
      this.minutes = 1;
      this.isSubmit = false;
      this.form.phone = null;
    },
    openPrevStep() {
      this.resetParams();
      this.setView("step_1");
      this.$log("authorization_resend");
    },
    prepareForm(form) {
      return {
        phone: this.form.phone.replace(/\s+/g, ""),
        code: this.form.code,
      };
    },
    async doAction() {
      if (this.isFirstStep()) {
        return this.sendCode();
      }

      this.verifyCode(this.prepareForm());
    },
    async sendCode() {
      this.isSubmit = true;
      this.isSended = true;

      try {
        this.setView("step_2");
        const response = await this.send(this.prepareForm());
        this.$log("authorization_number");
        this.startTimer();
      } catch (err) {
        if (err.response.status === 409) {
          this.$notify({
            title: this.$t("notifications.codeSent"),
            message: this.$t("notifications.codeSentText"),
            duration: 5000,
          });
        }
      }
    },
    sendAgain() {
      this.sendCode();
      this.isSended = true;
      this.minutes = 0;
      this.seconds = 59;
    },

    // main logic helpers
    isFirstStep() {
      return this.view == "step_1";
    },
    startTimer() {
      const dec = () => {
        if (this.seconds === 0) {
          this.isSended = false;
          this.seconds = 59;
          return;
        }

        setTimeout(() => {
          if (this.minutes == 1) {
            this.minutes = 0;
            this.seconds = 59;
          } else {
            if (this.seconds == 0) {
              this.isSended = false;
              return;
            }

            this.seconds = this.seconds - 1;
            this.seconds =
              this.seconds < 10 ? `0${this.seconds}` : this.seconds;
          }

          dec();
        }, 1000);
      };

      dec();
    },
    setView(v) {
      this.view = v;
    },

    // validation
    checkValue(v) {
      this.isValidPhone = v.valid && v.type == "mobile";
    },
  },
  created() {
    this.defaultCountry = this.$config.project == "hilfy" ? "at" : "de";
  },
};
</script>

<style lang="scss" scoped>
.visible {
  visibility: hidden;
  animation: hide 0.5s ease-in;

  &_undo {
    visibility: visible;
  }
}

@keyframes hide {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
</style>
